// extracted by mini-css-extract-plugin
export default {"TermsAndConditions":"TermsAndConditions_TermsAndConditions__bwqsy","title":"TermsAndConditions_title__hB2RN"};